import { PixelBuffer } from "../pixel/PixelBuffer";
import type { Selection } from "../selection/Selection";
import type { Filter } from "./Filter";

export interface TraceContourParams {
  level: number;
  direction: "lighter" | "darker";
}

function clamp8(v: number): number {
  return v < 0 ? 0 : v > 255 ? 255 : v;
}

export const TraceContour: Filter<TraceContourParams> = {
  id: "trace-contour",
  displayName: "Trace Contour",
  defaultParams: { level: 128, direction: "lighter" },

  apply(input: PixelBuffer, params: TraceContourParams, _selection: Selection | null): PixelBuffer {
    const w = input.width;
    const h = input.height;
    const out = new PixelBuffer(w, h, input.mode);
    const src = input.data;
    const dst = out.data;

    if (w === 0 || h === 0) { dst.set(src); return out; }

    const level = params.level;

    for (let y = 0; y < h; y++) {
      for (let x = 0; x < w; x++) {
        const o = (y * w + x) * 4;
        const lum = src[o]! * 0.299 + src[o + 1]! * 0.587 + src[o + 2]! * 0.114;

        let isEdge = false;
        if (x > 0) {
          const leftLum = src[(y * w + x - 1) * 4]! * 0.299 + src[(y * w + x - 1) * 4 + 1]! * 0.587 + src[(y * w + x - 1) * 4 + 2]! * 0.114;
          if (params.direction === "lighter") {
            isEdge = lum >= level && leftLum < level;
          } else {
            isEdge = lum <= level && leftLum > level;
          }
        }
        if (y > 0 && !isEdge) {
          const topLum = src[((y - 1) * w + x) * 4]! * 0.299 + src[((y - 1) * w + x) * 4 + 1]! * 0.587 + src[((y - 1) * w + x) * 4 + 2]! * 0.114;
          if (params.direction === "lighter") {
            isEdge = lum >= level && topLum < level;
          } else {
            isEdge = lum <= level && topLum > level;
          }
        }

        if (isEdge) {
          dst[o] = 0; dst[o + 1] = 0; dst[o + 2] = 0; dst[o + 3] = 255;
        } else {
          dst[o] = 255; dst[o + 1] = 255; dst[o + 2] = 255; dst[o + 3] = 255;
        }
      }
    }
    return out;
  },
};
